import * as React from "react";
import {ISvgIconProps, SvgIcon} from '../../../../basic-ui-components/icon/svg-icon/svg.icon';

export interface IHomeIconProps extends ISvgIconProps {

}

export class HomeIcon extends React.Component<IHomeIconProps> {
    render() {
        return (
            <SvgIcon {...this.props}>
                <g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5">
                    <path d="M3.266 11.436 12 4.111l8.734 7.325"/>
                    <path d="M16.508 5.52v-.845h2.817v3.381"/>
                    <path d="M4.675 12.564v7.325h5.071v-5.917h4.508v5.917h5.071v-7.325"/>
                </g>

                {/* <g fill="currentColor">
                    <path d="M19.159 12.438a0.598 0.598 0 0 1 -0.386 -0.14l-6.602 -5.537 -6.602 5.537a0.6 0.6 0 1 1 -0.771 -0.919l6.987 -5.86a0.6 0.6 0 0 1 0.771 0l6.987 5.86a0.6 0.6 0 0 1 -0.386 1.06Z"/>
                    <path d="M18.032 9.734a0.6 0.6 0 0 1 -0.6 -0.6V7.029h-1.054v0.08a0.6 0.6 0 1 1 -1.2 0v-0.68a0.6 0.6 0 0 1 0.6 -0.6h2.254a0.6 0.6 0 0 1 0.6 0.6v2.705a0.6 0.6 0 0 1 -0.6 0.6Z"/>
                    <path d="M18.033 19.2h-4.058a0.6 0.6 0 0 1 -0.6 -0.6v-4.134h-2.406v4.134a0.6 0.6 0 0 1 -0.6 0.6H6.312a0.6 0.6 0 0 1 -0.6 -0.6v-5.86a0.6 0.6 0 1 1 1.2 0V18h2.857v-4.134a0.6 0.6 0 0 1 0.6 -0.6h3.606a0.6 0.6 0 0 1 0.6 0.6V18h2.857v-5.26a0.6 0.6 0 0 1 1.2 0v5.86a0.6 0.6 0 0 1 -0.599 0.6Z"/>
                </g> */}
            </SvgIcon>
        );
    }
}
